import schemaToTypeGuard from 'sitemodel/schema/util/schemaToTypeGuard'
import schemaToReactType from 'sitemodel/schema/util/schemaToReactType'
import ProcessmodelSchema from 'sitemodel/schema/components/ProcessmodelSchema'

export type ProcessEventData = {
  tokenUuid: string
}

export type ProcessModelContainerProps = schemaToReactType<
  typeof ProcessmodelSchema
>

export const ProcessmodelContainerTypeGuard =
  schemaToTypeGuard(ProcessmodelSchema)
